import SkyNetTable from 'app/shared-components/SkyNetTable'
import SkyNetDomain, {
    SidebarTab,
} from 'app/shared-components/SkyNetDomain'
import useTabsByPermission from 'app/hooks/useTabsByPermission'
import {
    TableControlTypes,
} from 'app/shared-components/TableControls'
import useHasPermission from 'app/hooks/useHasPermission'

import useOrderManagementRoutes from 'app/SkyNetRoutes/hooks/useOrderManagementRoutes'
import {
    RequestKeys,
} from 'app/hooks/useRequest'

import {
    StatusLongTermLease,
} from 'app/enums/label.enums'
import requestConfig from 'app/requests/LongTermLease/LongTermLease.requests'
import tableConfig from './longTermLease.config'
import LongTermLeaseForm from './LongTermLeaseForm'
import LongTermLeaseOverview from './LongTermLeaseOverview'
import Containers from './Containers'
import ContractChangeHistory from './ContractChangeHistory'
import RelatedOrders from './RelatedOrders'
import LongTermLeaseUpdate from './LongTermLeaseUpdate'

const tableControls: TableControlTypes[] = [
    TableControlTypes.Search,
    TableControlTypes.ClearFilters,
    TableControlTypes.ClearSorting,
]

const LongTermLease = () => {
    const {
        LongTermLease: LongTermLeaseRoutes,
    } = useOrderManagementRoutes()

    const canCreate = useHasPermission(['long_term_lease_create'])
    const canUpdate = useHasPermission(['long_term_lease_update'])

    const tabs: SidebarTab[] = useTabsByPermission([
        {
            tab: {
                label: 'Overview',
                url: LongTermLeaseRoutes.Overview.route,
                Component: LongTermLeaseOverview,
            },
            permission: true,
        },
        {
            tab: {
                label: 'Data Update',
                url: LongTermLeaseRoutes.Update.route,
                Component: LongTermLeaseUpdate,
            },
            permission: canUpdate,
        },
        {
            tab: {
                label: 'Containers',
                url: LongTermLeaseRoutes.Containers.route,
                Component: Containers,
                condition: (data) => {
                    return data?.status !== StatusLongTermLease.NOT_STARTED
                },
            },
            permission: true,
        },
        {
            tab: {
                label: 'Related Orders',
                url: LongTermLeaseRoutes.RelatedOrders.route,
                Component: RelatedOrders,
            },
            permission: true,
        },
        {
            tab: {
                label: 'Contract Change History',
                url: LongTermLeaseRoutes.ContractChangeHistory.route,
                Component: ContractChangeHistory,
            },
            permission: true,
        },
    ])

    return (
        <SkyNetDomain
            name="LongTermLease"
            sidebarTabs={tabs}
            defaultTab={LongTermLeaseRoutes.Overview.route}
            getDomainObject={requestConfig.get}
            domainRequestKey={RequestKeys.getLongTermLease}
            actionComponents={{
                Create: canCreate ? LongTermLeaseForm : null,
            }}
        >
            <SkyNetTable
                tableControls={tableControls}
                tableConfig={tableConfig}
            />
        </SkyNetDomain>
    )
}

export default LongTermLease
